import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/about/page.tsx");
